import Color from '@/Enums/Color.enum';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import type { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { type ReactNode, useMemo } from 'react';

const TooltipContent = styled('span')({
  color: Color.Primary,
  fontSize: '14px',
  fontWeight: 600,
});

const TooltipRoot = (props: { children?: ReactNode }) => (
  <div
    key={'radius'}
    className='flex px-3 py-1 border border-[#DADADA] rounded-full cursor-default hover:border-[#1B4332] hover:bg-[#1b43320a]'
  >
    {props.children}
  </div>
);

const GeographyChips = ({ value: locationsArray, row }: GridRenderCellParams) => {
  const locations = useMemo(
    () =>
      Array.isArray(locationsArray) &&
      locationsArray?.reduce((acc, { displayName, type }) => {
        if (!acc[type]) {
          acc[type] = [displayName];
        } else {
          acc[type].push(displayName);
        }
        return acc;
      }, {}),
    [locationsArray],
  );

  return Array.isArray(locationsArray) || row?.geo_fence ? (
    <div className='flex gap-1'>
      {row?.geo_fence && (
        <TooltipRoot key={'radius'}>
          <Tooltip title={`${row.geo_fence.address}, ${row.geo_fence.radius} miles`} placement='top'>
            <TooltipContent>Radius</TooltipContent>
          </Tooltip>
        </TooltipRoot>
      )}
      {Object.keys(locations).map((key, idx) => {
        if (!locations[key]?.length) {
          return;
        }
        const tooltipTitle = (
          <ul>
            {locations[key].slice(0, 10).map((value: string) => (
              <li key={value}>{value}</li>
            ))}

            {locations[key].length > 10 && <li>and {locations[key].length - 10} others</li>}
          </ul>
        );
        return (
          <TooltipRoot key={idx}>
            <Tooltip title={tooltipTitle} placement='top'>
              <TooltipContent>{key}</TooltipContent>
            </Tooltip>
          </TooltipRoot>
        );
      })}
    </div>
  ) : (
    'United States'
  );
};

export default GeographyChips;
